import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoOrcamentoReprovado from './ContentSolicitacaoFluxoOrcamentoReprovado';

const SolicitacaoFluxoOrcamentoReprovado = () => {
  return (
    <>
      <HeaderApp />
      <ContentSolicitacaoFluxoOrcamentoReprovado />
      <Bottom />
    </>
  );
};

export default SolicitacaoFluxoOrcamentoReprovado;
